import { get, writable } from "svelte/store";
import api from "$utils/api";
import type { PrivateWriteUser } from "@outverse-video/outverse-api-client-lib";

export interface User extends PrivateWriteUser {
  isAuthed: true;
}

export interface AnonUser {
  isAuthed: false;
}

export type MaybeUser = User | AnonUser;

export const userStore = (user: PrivateWriteUser | null) => {
  let maybeUser: MaybeUser = { isAuthed: false };
  if (user) {
    maybeUser = { ...user, isAuthed: true };
  }
  const store = writable<MaybeUser>(maybeUser);
  const { subscribe, set, update } = store;

  return {
    subscribe,
    update,
    set,
    updatePreferences: (preferences: any) => {
      update((user) => {
        if (user.isAuthed) {
          return { ...user, preferences };
        }
        return user;
      });
    },
    save: () => {
      const user = get(store);
      if (user.isAuthed) {
        return api.apiUsersMePartialUpdate({ patchedPrivateWriteUser: user });
      }
    },
  };
};
export type UserStore = ReturnType<typeof userStore>;
